/* eslint react/jsx-key: off */
import { BooleanField, Datagrid, List, TextField } from 'react-admin';
import ControlEditEmbedded from './ControlEditEmbedded';

const ControlList = () => {
  return (
    <List queryOptions={{ refetchInterval: 5000 }} sort={{ field: 'name', order: 'DESC' }}>
      <Datagrid expand={<ControlEditEmbedded />} rowClick="expand" optimized>
        <TextField source="id" />
        <TextField source="type" />
        <TextField source="name" />
        <BooleanField source="is_honest_bar" />
      </Datagrid>
    </List>
  );
};

export default ControlList;
